import { render, staticRenderFns } from "./example-test.vue?vue&type=template&id=9d83e700&"
import script from "./example-test.vue?vue&type=script&lang=js&"
export * from "./example-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports